import React from 'react';
import StyledBox from 'views/membership-module/MembershipView/components/HeaderSection/HeaderSection.styles';
import { useTranslation } from 'next-i18next';
import { Typography700 } from 'views/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import { Button } from '@mui/material';

import NavigatorLink from 'views/common/components/Logical/NavigatorLink';

const HeaderSection = (props) => {
  const {
    title,
    titleHint,
    subTitle,
    orangeHint,
    orangeTitle,
    getSubscribeNowPath,
  } = props;
  const { t } = useTranslation('fe_er_membership_page');

  return (
    <StyledBox>
      <Typography700
        component="p"
        className={`HSTitle ${orangeTitle && 'HSOrange'} `}>
        {title}
        <Typography700
          component="span"
          className={`HSTitle HSTitleHint ${orangeHint && 'HSOrange'} `}>
          {titleHint}
        </Typography700>
      </Typography700>
      <Typography500 varant="h5" className="HSSubTitle">
        {subTitle}
      </Typography500>
      <Button
        href={getSubscribeNowPath()}
        variant="contained"
        className="HSBtn"
        component={NavigatorLink}>
        {t('fe_er_membership_page:subscribe_now')}
      </Button>
    </StyledBox>
  );
};

export { HeaderSection };
